import styled from "styled-components";

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ::-webkit-scrollbar {
    display: none;
  }
`;

export { Container };